<template>
  <div v-if="!loading">
    <b-form-group label="انتخاب دوره" label-for="add-semester-courses">
      <validation-provider #default="{ errors }" name="courses" vid="courses">
        <select-box
          v-model="selectedCourses"
          multiple
          label="text"
          url="course"
          searchable
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
    <b-form-group
      label="رویداد ها"
      label-for="add-semester-events"
      class="w-100"
    >
      <validation-provider
        #default="{ errors }"
        name="events"
        vid="events"
        class="d-flex justify-content-start align-items-center"
      >
        <select-box
          v-model="selectedEvents"
          multiple
          label="text"
          class="w-100"
          url="event"
          searchable
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
    <draggable
      v-model="roadmaps"
      class="list-group list-group-flush cursor-move"
      tag="ul"
    >
      <b-list-group-item
        v-for="(item, index) in roadmaps"
        :key="'item-' + index"
        tag="li"
        class="d-flex justify-content-between"
      >
        <span>{{ item.text }}</span>
        <roadmap-item v-model="item.vip" :propVip="item.vip" />
      </b-list-group-item>
    </draggable>
  </div>
</template>

<script>
import { BFormCheckbox, BListGroupItem, BFormGroup } from "bootstrap-vue";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import RoadmapItem from "./RoadmapItem.vue";
import draggable from "vuedraggable";
export default {
  components: {
    BFormCheckbox,
    BListGroupItem,
    BFormGroup,
    SelectBox,
    ValidationProvider,
    ValidationObserver,
    draggable,
    RoadmapItem,
  },
  props: {
    propRoadmaps: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      roadmaps: [],
      selectedCourses: [],
      selectedEvents: [],
      tempRoadMaps: [],
      loading: false,
    };
  },
  async created() {
    this.loading = true;
    this.tempRoadMaps = [...this.propRoadmaps];
    // this.selectedCourses = [...this.propRoadmaps];
    // this.selectedEvents = [...this.propRoadmaps];

    if (this.propRoadmaps.length) {
      this.selectedCourses = await this.propRoadmaps
        .filter((item) => item.type == "course")
        .map((item) => item.id);
      this.selectedEvents = await this.propRoadmaps
        .filter((item) => item.type == "event")
        .map((item) => item.id);
    }
    this.loading = false;
  },
  watch: {
    selectedCourses(newVal) {
      if (newVal.length) {
        if (newVal.findIndex((item) => item.id) > -1) {
          this.setRoadMap(newVal, "course");
        }
      } else {
        this.roadmaps.map((item, index) => {
          if (item.type == "course") {
            this.roadmaps.splice(index, 1);
          }
        });
      }
    },
    selectedEvents(newVal) {
      if (newVal.length) {
        if (newVal.findIndex((item) => item.id) > -1) {
          this.setRoadMap(newVal, "event");
        }
      } else {
        this.roadmaps.map((item, index) => {
          if (item.type == "event") {
            this.roadmaps.splice(index, 1);
          }
        });
      }
    },
    roadmaps: {
      handler(newVal) {
        this.$emit("input", newVal);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async setRoadMap(newVal, type) {
      newVal.forEach((val) => {
        let found = this.tempRoadMaps.find(
          (temp) => temp.id == val.id && temp.type == type
        );
        if (found && Object.keys(found).length) {
          val.vip = found.vip;
          val.type = found.type;
        } else {
          val.vip = 0;
          val.type = type;
        }
      });

      const notFound = newVal.filter(
        (val) =>
          this.roadmaps.findIndex(
            (item) => item.id === val.id && item.type === val.type
          ) === -1
      );
      if (notFound.length) {
        this.roadmaps.push(...notFound);
      }
      const sameType = this.roadmaps.filter((item) => item.type == type);

      if (sameType.length > newVal.length) {
        let difference = sameType.filter((item) => !newVal.includes(item));
        this.roadmaps.map((item, index) => {
          difference.map((diff) => {
            if (diff.id == item.id && item.type == diff.type) {
              this.roadmaps.splice(index, 1);
            }
          });
        });
      }
    },
  },
};
</script>

<style></style>
